<div>
  <module-container>
    <div class="title-container">
      <h2>Store In Priority</h2>
    </div>
    <div class="store-priority-table-container">
      <p-table [value]="storesInPriority" [resizableColumns]="true">
        <ng-template pTemplate="header">
          <tr>
            <th [style.width]="'110px'" pResizableColumn>Store ID</th>
            <th pResizableColumn>Name</th>
            <th [style.width]="'110px'" pResizableColumn>Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-store>
          <tr>
            <td class="center">{{ store.storeId }}</td>
            <td>{{ store.storeName }}</td>
            <td class="center">
              <button
                mat-flat-button
                class="priority-button"
                color="warn"
                (click)="removePriority(store.storeId)"
                type="button"
              >
                Remove
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3" class="center">No stores in priority</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="remove-all-container">
      <button
        mat-flat-button
        class="priority-button"
        color="warn"
        (click)="removeAllPriority()"
        [disabled]="!storesInPriority || storesInPriority.length === 0"
        type="button"
      >
        Remove All
      </button>
    </div>
    <h2>Set store priority</h2>
    <form [formGroup]="selectStoreForm" class="select-form-container" (ngSubmit)="setPriority()">
      <div class="store-select-field">
        <!-- Enhanced with smart search and bulk selection -->
        <primeng-multiselect
          formControlName="selectedStore"
          [setUrl]="storeUrl"
          [placeholder]="'Search stores (type store name, ID, or location)...'"
          [baseMaxResults]="1000"
          [pageSize]="50"
          [allowMultipleFromSearch]="true"
          [isFilterOnly]="false"
          [isSingle]="false"
          (onChange)="setValue($event)"
        ></primeng-multiselect>
      </div>
      <div class="select-store-button-container">
        <form-button type="submit" [formButton]="priorityButton"></form-button>
      </div>
    </form>
  </module-container>
</div>
